const HTTP_URL = /^https?:\/\//i

const PUBLIC_PGA_COM_HOSTS = new Set([
  'pga.com',
  'www.pga.com',
  'dev.pga.com',
])

const MY_PGA_COM_HOSTS = new Set([
  'my.pga.com',
  'my.dev.pga.com',
])

function hostnameFrom(url) {
  try {
    return new URL(url).hostname.toLowerCase()
  } catch {
    return ''
  }
}

export function isPublicPgaComHostname(hostname) {
  const host = (hostname || '').toLowerCase()
  if (!host) return false
  if (PUBLIC_PGA_COM_HOSTS.has(host)) return true
  if (host.endsWith('.pr.dev.pga.com')) return true
  const siteHost = hostnameFrom(process.env.PGA_COM_URL || '')
  return Boolean(siteHost && siteHost === host && !siteHost.startsWith('my.'))
}

export function isMyPgaComHostname(hostname) {
  const host = (hostname || '').toLowerCase()
  if (!host) return false
  if (MY_PGA_COM_HOSTS.has(host)) return true
  const myHost = hostnameFrom(process.env.MY_PGA_COM_URL || '')
  return Boolean(myHost && myHost === host)
}

/**
 * Shop / offering CTAs: public PGA.com URLs stay on this site
 * (relative path, same tab). my.pga.com / my.dev.pga.com stay
 * absolute (different origin) but open in the same tab. Other
 * http(s) hosts stay absolute and open in a new tab. Non-http
 * values other than a rooted `/path` (not `//`) are rejected.
 */
export function resolveOfferingCtaLink(url) {
  if (!url) {
    return { href: null, isExternal: false }
  }
  if (!HTTP_URL.test(url)) {
    if (url.startsWith('/') && !url.startsWith('//')) {
      return { href: url, isExternal: false }
    }
    return { href: null, isExternal: false }
  }
  let parsed
  try {
    parsed = new URL(url)
  } catch {
    return { href: null, isExternal: false }
  }
  if (isPublicPgaComHostname(parsed.hostname)) {
    return {
      href: `${parsed.pathname}${parsed.search}${parsed.hash}`,
      isExternal: false,
    }
  }
  if (isMyPgaComHostname(parsed.hostname)) {
    return { href: url, isExternal: false }
  }
  return { href: url, isExternal: true }
}
